// Lays out the non-schema panels. Which of them appear depends on how the
// integration is triggered, which the caller decides.

import React from 'react';
import PropTypes from 'prop-types';

import { FormDivider, SectionDivider, SectionRow } from '../StyledComponents';
import AutomaticRetrySettings from '../AutomaticRetrySettings';
import CircuitBreakerSettings from '../CircuitBreakerSettings';
import IntegrationCacheSettings from '../IntegrationCacheSettings';
import IntegrationTimeoutSettings from '../IntegrationTimeoutSettings';

const SettingsPanels = ({
  edit,
  errors,
  panels,
  showCacheSettings = false,
  showCircuitBreakerSettings = false,
  showAutomaticRetrySettings = false,
  onToggleCacheModal,
  onShowTtlField,
}) => (
  <>
    {showCacheSettings && <FormDivider data-testid="feature-divider" />}
    {showCacheSettings && (
      <SectionRow>
        <IntegrationCacheSettings
          edit={edit}
          cacheEnabled={panels.cacheEnabled}
          cacheTTL={panels.cacheTTL}
          showTtlField={panels.showTtlField}
          errors={errors}
          handleToggleCacheModal={onToggleCacheModal}
          handleShowTtlField={onShowTtlField}
          handleTextChange={panels.handleTextChange}
          validateCacheTTL={panels.validateCacheTTL}
          setCacheEnabled={panels.setCacheEnabled}
        />
      </SectionRow>
    )}

    <SectionDivider data-testid="feature-divider" />
    {showCircuitBreakerSettings && (
      <SectionRow>
        <CircuitBreakerSettings
          edit={edit}
          circuitBreakerEnabled={panels.circuitBreakerEnabled}
          circuitBreakerRetryAfter={panels.circuitBreakerRetryAfter}
          circuitBreakerFailureThreshold={panels.circuitBreakerFailureThreshold}
          warningMessageFailureThresholdMessage={panels.failureThresholdWarning}
          handleTextChange={panels.handleTextChange}
          setCircuitBreakerEnabled={panels.setCircuitBreakerEnabled}
        />
      </SectionRow>
    )}

    {showAutomaticRetrySettings && (
      <SectionDivider data-testid="feature-divider" />
    )}
    {showAutomaticRetrySettings && (
      <SectionRow>
        <AutomaticRetrySettings
          edit={edit}
          automaticRetryEnabled={panels.automaticRetryEnabled}
          retryAfter={panels.retryAfter}
          maxRetries={panels.maxRetries}
          warningMessageMaxRetryAfterMessage={panels.maxRetriesWarning}
          handleTextChange={panels.handleTextChange}
          setAutomaticRetryEnabled={panels.setAutomaticRetryEnabled}
        />
      </SectionRow>
    )}

    <SectionDivider data-testid="feature-divider" />
    <SectionRow>
      <IntegrationTimeoutSettings
        edit={edit}
        timeout={panels.timeout}
        errors={errors}
        handleTextChange={panels.handleTextChange}
        validateTimeout={panels.validateTimeout}
      />
    </SectionRow>
  </>
);

SettingsPanels.propTypes = {
  edit: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  panels: PropTypes.object.isRequired,
  showCacheSettings: PropTypes.bool,
  showCircuitBreakerSettings: PropTypes.bool,
  showAutomaticRetrySettings: PropTypes.bool,
  onToggleCacheModal: PropTypes.func.isRequired,
  onShowTtlField: PropTypes.func.isRequired,
};
export default SettingsPanels;
